// src/pages/Resurse.jsx
import React from "react";
import Title from "../components/ui/Title";
import SectionTitle from "../components/ui/SectionTitle";
import PrimaryButton from "../components/ui/PrimaryButton";

export default function Resurse() {
  return (
    <section className="p-6 max-w-4xl mx-auto space-y-6 text-text-body">
      <Title>Resurse</Title>

      <div className="space-y-4">
        <div className="flex flex-wrap items-center gap-2">
          <PrimaryButton
            as="a"
            href="https://substack.com/@traitordedesign"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm px-5 py-2"
            title="Se deschide pagina Substack – Jurnal de Design Trăit"
          >
            Jurnalul unui Trăitor de Design
          </PrimaryButton>
          <span className="text-sm text-text-body">
            – reflecții autentice despre procesul trăirii Designului
          </span>
        </div>

        <div>
          <SectionTitle>PDF-uri utile</SectionTitle>
          <ul className="list-disc list-inside space-y-1">
            <li>Ghid pentru începutul în Human Design</li>
            <li>Întrebări de reflecție pentru fiecare Centru</li>
            <li>Resurse recomandate de studiu (linkuri externe)</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
